
// Takes response array, returns formatted "Msg"
export const formatDeleteErrorMessage = (data=[]) => {
    try {
        let msg = data[0].Msg;

        for (let i = 1; i < data.length; i++) {
            const stringArr = data[i].Msg.split(" ")
            msg += ", "
            msg += stringArr[stringArr.length-1]
        }
        return msg;
    } catch (error) {
        return "";
    }
}